import type { EditableOutstandingBill } from '../types/bills.types';

export const splitOutstandingBills = (bills: EditableOutstandingBill[]) =>
  bills.reduce(
    (acc, bill) => {
      if (bill.HasPendingArPosting) {
        acc.pending.push(bill);
      } else {
        acc.outstanding.push(bill);
      }
      return acc;
    },
    {
      outstanding: [] as EditableOutstandingBill[],
      pending: [] as EditableOutstandingBill[],
    }
  );
